// src/utils/walkthroughReplay.js
//
// How Help asks the first sign-in walkthrough to play again
// (docs/changes/help-module/SPEC.md, decisions 4-7). Help navigates Home with
// this state; the walkthrough's mount point, which watches the route, reads it,
// plays every step of the person's version and records nothing. Browsers keep
// history state across a reload, so the reader clears it before it starts.

import { track } from "./analytics";

const REPLAY = "replay";

/** Go Home and ask the walkthrough to replay, counted apart from first runs. */
export function requestWalkthroughReplay(navigate) {
  track("walkthrough_replay");
  navigate("/", { state: { walkthrough: REPLAY } });
}

/** True for the location state requestWalkthroughReplay leaves behind. */
export function isWalkthroughReplay(state) {
  return state?.walkthrough === REPLAY;
}
